import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { blurOnEnter } from '../../utility/certificationBuilder'
import SettingsCard from './SettingsCard'
import BuilderField from './BuilderField'
import CoverImageField from './CoverImageField'
import InstructorsField from './InstructorsField'
import Input from '../common/form/Input'

import classes from './CertificationDetailsCard.module.scss'

const CertificationDetailsCard = ({ certification, form, errors, onChange, onBlur }) => {
  const { t } = useTranslation()

  return (
    <SettingsCard eyebrow={t('certificationBuilder.details.eyebrow')}>
      <div className={classes.titleRow}>
        <BuilderField label={t('certificationBuilder.details.title')} htmlFor='certificationName' required>
          <Input
            id='certificationName'
            type='text'
            value={form.name}
            onChange={(e) => onChange('name', e.target.value)}
            onBlur={() => onBlur('name')}
            onKeyDown={blurOnEnter}
            error={errors.name}
          />
        </BuilderField>
        <BuilderField label={t('certificationBuilder.details.level')} htmlFor='certificationLevel'>
          <Input
            id='certificationLevel'
            type='number'
            min={1}
            value={form.level}
            onChange={(e) => onChange('level', e.target.value)}
            onBlur={() => onBlur('level')}
            onKeyDown={blurOnEnter}
            error={errors.level}
          />
        </BuilderField>
      </div>

      <BuilderField label={t('certificationBuilder.details.description')} htmlFor='certificationDescription'>
        <Input
          id='certificationDescription'
          type='textarea'
          value={form.description}
          onChange={(e) => onChange('description', e.target.value)}
          onBlur={() => onBlur('description')}
          classNames={{ inputContainer: classes.description }}
        />
      </BuilderField>

      <BuilderField
        label={t('certificationBuilder.details.bullets')}
        htmlFor='certificationBullets'
        hint={t('certificationBuilder.details.bulletsHint')}
      >
        <Input
          id='certificationBullets'
          type='textarea'
          value={form.bullets}
          onChange={(e) => onChange('bullets', e.target.value)}
          onBlur={() => onBlur('bullets')}
          classNames={{ inputContainer: classes.bullets }}
        />
      </BuilderField>

      <div className={classes.pairRow}>
        <CoverImageField certification={certification} />
        <InstructorsField certification={certification} />
      </div>
    </SettingsCard>
  )
}

CertificationDetailsCard.propTypes = {
  certification: PropTypes.object.isRequired,
  form: PropTypes.shape({
    name: PropTypes.string.isRequired,
    level: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    bullets: PropTypes.string.isRequired,
  }).isRequired,
  errors: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
}

export default CertificationDetailsCard
